const AdmissionProcessFullTimeSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
      <g clipPath="url(#clip0_5350_68220)">
        <path
          d="M8.23447 23.7344C7.05041 23.7344 6.04025 24.4936 5.66504 25.5508H10.8038C10.4287 24.4936 9.41852 23.7344 8.23447 23.7344Z"
          fill="#5D6977"
        />
        <path
          d="M8.23438 20.1016C8.73596 20.1016 9.14258 19.6949 9.14258 19.1934C9.14258 18.6918 8.73596 18.2852 8.23438 18.2852C7.73279 18.2852 7.32617 18.6918 7.32617 19.1934C7.32617 19.6949 7.73279 20.1016 8.23438 20.1016Z"
          fill="#5D6977"
        />
        <path
          d="M25.4902 12.8359V15.8719L15.5 18.3694L9.75277 16.9327C10.4797 17.4224 10.959 18.2528 10.959 19.1934C10.959 20.6958 9.73678 21.918 8.23438 21.918C10.7382 21.918 12.7754 23.9552 12.7754 26.459V27.3672H3.69336V26.459C3.69336 23.9552 5.73058 21.918 8.23438 21.918C6.73197 21.918 5.50977 20.6958 5.50977 19.1934C5.50977 17.7731 6.60578 16.6167 7.99437 16.493L5.50977 15.8719V12.8538L0 12.8359V31H31V12.8359H25.4902ZM20.041 18.2852H21.8574V20.1016H20.041V18.2852ZM16.4082 18.2852H18.2246V20.1016H16.4082V18.2852ZM25.4902 27.3672H16.4082V25.5508H25.4902V27.3672ZM25.4902 23.7344H16.4082V21.918H25.4902V23.7344ZM25.4902 20.1016H23.6738V18.2852H25.4902V20.1016Z"
          fill="#5D6977"
        />
        <path d="M15.5 11.0993L0 4.48919L15.5 0L31 4.48919L15.5 11.0993Z" fill="#5D6977" />
        <path d="M15.5 13.0754L7.32617 9.57062V14.4537L15.5 16.4971L23.6738 14.4537V9.57062L15.5 13.0754Z" fill="#5D6977" />
        <path d="M25.4902 8.79182V11.0195H27.3066V8.013L25.4902 8.79182Z" fill="#5D6977" />
      </g>
      <defs>
        <clipPath id="clip0_5350_68220">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdmissionProcessFullTimeSvg;
